import * as React from "react";
import {
  createStyles,
  makeStyles,
  Typography,
  useTheme,
  Box,
  ButtonBase,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ColorPickerDialog from "../../../components/dialogs/ColorPickerDialog";
import ColorPickerPopup from "../../../components/popovers/ColorPickerPopup";
import { useMediaQuery } from "@material-ui/core";
import { CustomTheme } from "../../../../../types/customTheme";

interface Props {
  colorCode: string;
}

const useStyles = makeStyles<any, Props>((theme: CustomTheme) =>
  createStyles({
    // The main container styled as a form input
    selectorContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      height: "40px",
      padding: "0 12px",
      borderRadius: "10px",
      border: `1px solid ${theme.palette.background.entity_border || "rgba(255, 255, 255, 0.23)"}`,
      backgroundColor: "transparent",
      cursor: "pointer",
      transition: "border-color 0.2s",
      "&:hover": {
        border: `1px solid ${theme.palette.text.primary}`,
      },
    },
    // The rounded square color preview
    colorBox: {
      borderRadius: "50%", // Change to 4px if you want a rounded square like the image
      width: 20,
      height: 20,
      backgroundColor: ({ colorCode }) => colorCode || "#FFBA00",
      marginRight: 10,
    },
    hexText: {
      color: "#fff",
      fontSize: "0.875rem",
      fontWeight: 500,
      textTransform: "uppercase",
    },
    arrowIcon: {
      color: "#8b949e",
    },
  })
);

export interface ColorSelectionProps {
  title: string;
  colorCode: string;
  setColor: any;
  setInitialData: any;
}

const ColorSelectionIconButton: React.FunctionComponent<ColorSelectionProps> = ({
  title,
  colorCode,
  setColor,
  setInitialData,
}) => {
  const [openPicker, setOpenPicker] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles({ colorCode });

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      {matches ? (
        <ColorPickerDialog
          open={openPicker}
          setOpen={setOpenPicker}
          color={colorCode}
          setColor={setColor}
          setInitialData={setInitialData}
        />
      ) : (
        <ColorPickerPopup
          open={open}
          color={colorCode}
          setColor={setColor}
          handleClose={handleClose}
          anchorEl={anchorEl}
        />
      )}

      {/* Replaced IconButton with a styled ButtonBase to look like a Select input */}
      <ButtonBase
        component="div"
        className={classes.selectorContainer}
        onClick={matches ? () => setOpenPicker(true) : handleClick}
      >
        <Box display="flex" alignItems="center">
          <div className={classes.colorBox} />
          <Typography className={classes.hexText}>
            {colorCode || "#FFBA00"}
          </Typography>
        </Box>
        <ArrowDropDownIcon className={classes.arrowIcon} />
      </ButtonBase>
    </>
  );
};

export default ColorSelectionIconButton;